import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { shouldShowSafetyNotice } from "../utils/safetyNotice";

type SafetyNoticeProps = {
  passengers: number;
  luggage: number;
};

export default function SafetyNotice({ passengers, luggage }: SafetyNoticeProps) {
  const { t } = useTranslation();

  if (!shouldShowSafetyNotice(passengers, luggage)) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.25,
        mt: 1.5,
        p: 1.75,
        borderRadius: "12px",
        background: "#FFF3E0",
        border: "1px solid #FFB74D",
      }}
    >
      <Box
        component="span"
        sx={{
          color: "#C62828",
          fontSize: "20px",
          lineHeight: 1.2,
        }}
      >
        {"\u26A0\uFE0F"}
      </Box>
      <Box>
        <Typography
          sx={{
            color: "#C62828",
            fontWeight: 700,
            fontSize: "14px",
          }}
        >
          {t("safetyComplianceNoticeOverloadTitle", {
            passengers,
            luggage,
          })}
        </Typography>
        <Typography
          sx={{
            color: "#C62828",
            fontSize: "13px",
            mt: 0.5,
          }}
        >
          {t("safetyComplianceNoticeDesc")}
        </Typography>
      </Box>
    </Box>
  );
}
